import { useCart } from "../../context/CartContext";
import { getSizeType } from "../../utils/itemUtils";

const CartItem = ({ item }) => {
  const { updateQuantity } = useCart();

  return (
    <div className="bg-white rounded-lg px-4 py-1 border-b border-gray-100">
      <div className="flex items-center gap-3 mb-2">
        {/* Dish Name */}
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h4 className="font-semibold text-sm">{item.name}</h4>
          </div>
          {item?.addons && item?.addons?.length > 0 && (
            <p className="text-[10px] text-gray-600 mt-0.5">
              + {item?.addons?.map((a) => a.name).join(", ")}
            </p>
          )}
          {item?.selectedPortion && (
            <p style={{ fontSize: "9px" }} className="bg-green-500 w-max pt-0.5 text-white px-1 rounded mt-0.5">
              {getSizeType(item.selectedPortion, item)}
            </p>
          )}
        </div>

        <div className="flex items-center gap-2 flex-">
          {/* Quantity Controls - Moved to front */}
          <div className="flex items-center gap-2 bg-gray-100 rounded-lg px-2 py-1">
            <button
              onClick={() => updateQuantity(item.cartId, -1)}
              className="text-gray-600 hover:text-gray-800 font-bold"
              aria-label="Decrease quantity"
            >
              <svg
                className="w-3 h-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                  d="M20 12H4"
                />
              </svg>
            </button>
            <span className="font-semibold text-sm w-4 text-center">{item.quantity}</span>
            <button
              onClick={() => updateQuantity(item.cartId, 1)}
              className="hover:opacity-80 font-bold"
              style={{ color: "#0B9444" }}
              aria-label="Increase quantity"
            >
              <svg
                className="w-3 h-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </button>
          </div>

          {/* Price */}
          <div className="flex flex-col items-end">
            {item.hasDiscount && (
              <span className="text-xs text-gray-400 line-through">
                ₹{item.originalPrice * item.quantity}
              </span>
            )}
            <span className="font-bold text-sm" style={{ color: item.hasDiscount ? "#0B9444" : "inherit" }}>
              ₹{item.totalPrice * item.quantity}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
